import React from "react";
import { withTranslation } from 'react-i18next';
import { Filemanager } from "./filemanager";


class FilemanagerParent extends React.Component {
    constructor(props) {
        super(props);
        this.state = {

        }
    }
    render() {
        return <Filemanager {...this?.props} />;
    }
}
export default withTranslation('filemanager')(FilemanagerParent);

